var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"component",staticClass:"chart-wrapper",attrs:{"id":_vm.elementId}},[_c('pie-chart',{attrs:{"options":_vm.options,"styles":{
      width: (_vm.contentHeight + "px"),
    },"chart-data":_vm.chartDataSource}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }